import Utilities from '@/helpers/Utilities'
import StringHelpers from '@/helpers/StringHelpers'

export default class {

    static evalInContext(js, context) {

        this.addCommonFunctions(context)

        const expression = js.replace(/\$/g, 'this.')
        //# Return the results of the in-line anonymous function we .call with the passed context
        return function() { 
            let result
            try {
                result = eval(expression); 
            } catch (e) {
                result = 'EVAL_ERR'
            }
            return result 
        }.call(context);
    }

    static addCommonFunctions(context) {
        context.currency = function(val) {
            return StringHelpers.formatCurrency(val)
        }

        context.brackets = function(val, suffix) {
            if(!val)
                return val
            return '(' + val + (suffix || '') + ')'
        }
    }

    static processExpressions(str, context, schemas) {

        if(str.indexOf('[') < 0)
            return str

        const expressionArray = this.findExpressions(str)
        let newStr = str
        expressionArray.forEach(expression => {
            const result = this.evalInContext(expression, context)
            newStr = newStr.replace('[' + expression + ']', result)
        })

        // console.groupCollapsed('processExpressions')
        // console.log('Expressions', expressionArray)
        // console.log('Context', context)
        // console.log('Final string', newStr)
        // console.groupEnd()

        if(newStr == 'false' || newStr == 'EVAL_ERR' || newStr == 'null' || newStr == 'undefined')
            return false

        return newStr.replace(/null/g, '').trim()
    }
    
    static findExpressions(searchString) {

        //console.log('findMegeFields', searchString)
        
        let matches = {}
        let match
        
        do {
            match = String(searchString).match(/\[(.*?)\]/i)
            if(!match) 
                break

            let innerMatch = match[1]
            let outerMatch = match[0]

            matches[innerMatch] = true
            searchString = searchString.replace(outerMatch, '')

        } while(match)

        return Utilities.objectToArray(matches)
    }

    static trueLabels(schemas, value) {
        const labelArray = []
        schemas.forEach(schema => {
            if(value[schema.name] === true || value[schema.name + '_exists']) {
                //console.log('found true for', schema.name)
                labelArray.push(schema.title || schema.label || schema.name)
            }
        })

        return labelArray.join(', ') || 'None'
        // return StringHelpers.sentenceJoin(labelArray)
    }

}


// WEBPACK FOOTER //
// ./src/forms/Merger.js